(function(){
  function txt(el){return (el && el.textContent || '').replace(/\s+/g,' ').trim();}
  function mark(){
    var root=document.querySelector('.senlo-bestrack-shell');
    if(!root) return;

    var all=[].slice.call(root.querySelectorAll('*'));
    var trackBtn=all.find(function(el){
      var t=txt(el).toLowerCase();
      return (t==='track your order'||t==='track order') &&
        (el.tagName==='BUTTON'||el.tagName==='A'||el.getAttribute('role')==='button'||el.tagName==='DIV');
    });
    if(trackBtn){
      trackBtn.classList.add('senlo-bt-button');
      var p=trackBtn.parentElement;
      for(var i=0;p&&i<6;i++,p=p.parentElement){
        var s=txt(p).toLowerCase();
        if(s.indexOf('tracking number')>-1 && s.indexOf('order number')>-1){
          p.classList.add('senlo-bt-card');
          break;
        }
      }
    }

    root.querySelectorAll('input[type="text"],input[type="email"],input[type="tel"],input:not([type])').forEach(function(el){
      el.classList.add('senlo-bt-input');
    });

    all.forEach(function(el){
      var t=txt(el).toLowerCase();
      if(t==='tracking number'||t==='order number'){
        if(el.children.length===0 || el.tagName==='BUTTON' || el.getAttribute('role')==='tab'){
          el.classList.add('senlo-bt-tab');
          var style=getComputedStyle(el);
          if(style.borderBottomWidth!=='0px' || el.getAttribute('aria-selected')==='true'){
            if(el.getAttribute('aria-selected')==='true' || style.color==='rgb(17, 19, 21)' || style.fontWeight>='600'){
              el.classList.add('senlo-bt-tab-active');
            }
          }
        }
      }
    });

    var inputs=root.querySelectorAll('.senlo-bt-input');
    if(inputs.length){
      var card=inputs[0].parentElement;
      for(var j=0;card&&j<7;j++,card=card.parentElement){
        var ctext=txt(card).toLowerCase();
        if(ctext.indexOf('track your order')>-1 && ctext.indexOf('tracking number')>-1){
          card.classList.add('senlo-bt-card');
          break;
        }
      }
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mark);
  else mark();

  var root=document.querySelector('.senlo-bestrack-shell');
  if(root){
    var timer;
    new MutationObserver(function(){
      clearTimeout(timer);
      timer=setTimeout(mark,50);
    }).observe(root,{childList:true,subtree:true,attributes:true});
    setTimeout(mark,400);
    setTimeout(mark,1200);
    setTimeout(mark,2500);
  }
})();